<kPopupWidget
  #transcodingProfileSelectMenu
  data-aid="transcodingProfileSelectMenu"
  [popupWidth]="586"
  [popupHeight]="289"
  [closeBtn]="true"
  [modal]="true"
  [preventPageScroll]="true"
>
  <ng-template>
    <kTranscodingProfileSelect
      (onTranscodingProfileSelected)="_loadEntry($event)"
      [parentPopupWidget]="transcodingProfileSelectMenu"
      [mediaType]="_selectedMediaType"
    ></kTranscodingProfileSelect>
  </ng-template>
</kPopupWidget>
